module.exports = __webpack_public_path__ + "img/20190717163046041.056cce72.png";